<template>
  <div
    class="
      bg-black bg-opacity-10
      rounded
      border border-white border-opacity-40
      p-1
    "
  >
    <div class="relative">
      <div
        class="
          absolute
          rounded
          h-full
          bg-lime
          transition-all
          duration-500
          -z-10
        "
        :style="style"
      />
      <div class="grid gap-1 grid-flow-col">
        <label
          v-for="option in options"
          :key="option.value"
          class="inline-block focus-within:outline focus-within:outline-auto"
          ref="options"
        >
          <input
            type="radio"
            :name="name"
            :value="option.value"
            class="hidden peer"
            @change="handleChange"
            :checked="option.value === value"
          />
          <span
            class="
              block
              text-center 
              custom-label-tighter
              p-2
              rounded
              cursor-pointer
              peer-checked:pointer-events-none
              transition-colors
              font-[500]
            "
            v-text="option.label"
          ></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioGroupWithSlider',
  props: {
    name: String,
    options: Array,
    value: String,
  },
  data() {
    return { 
      style: null
    }
  },
  computed: {
    currentOption() {
      if (this.value === null) return null

      const option = this.options.find(
        (option) => option.value === this.value
      )

      return option || this.options[0]
    },
  },
  methods: {
    handleChange(e) {
      const { value } = e.target
      const activeOption = this.options.find((option) => option.value === value)
      this.$emit('input', activeOption.value)
    },
    reCalculateStyle() {
      // this is method and not computed because it depends on refs
      // and refs are undefined until component has mounted
      if (!this.currentOption) return null

      const index = this.options.indexOf(this.currentOption)

      if (Number.isNaN(index) || index === -1) return null

      const element = this.$refs.options && this.$refs.options[index]

      if (!element) return null

      this.style = {
        width: `${element.clientWidth}px`,
        transform: `translate(${element.offsetLeft}px, 0)`,
      }
    }
  },
  watch: {
    currentOption() {
      this.reCalculateStyle()
    },
  },
  mounted() {
    this.reCalculateStyle()
  }
}
</script>
